<template lang="html">
  <header id="header" v-bind:style="{ height: headerHeight+'px' }">
    <div class="header-content" id="header-content">
      <div class="container oversized-container">
        <div class="row">
          <div class="col col-logo">
            <router-link to="/dashboard" v-if="$root.logged">
              <img src="public/images/oz-toyota.png" alt="OZ TOYOTA">
            </router-link>
            <router-link to="/" v-else>
              <img src="public/images/oz-toyota.png" alt="OZ TOYOTA">
            </router-link>
          </div>

          <div class="col col-info"></div>

          <div class="col col-user" v-if="$root.logged">
            <!-- <div class="col col-notifications">
              <span class="n active">
                <i class="far fa-bell icon"></i>
              </span>
            </div> -->

            <div class="col col-sep"></div>

            <div class="col col-user-info">
              <!-- <div class="box-user-login">
                <router-link class="t-150" to="">
                  <i class="far fa-user icon"></i>
                  <span>Iniciar sesión</span>
                </router-link>
              </div> -->

              <div class="box-user-info">
                <div class="col placed-backg box-image" v-bind:style="{ backgroundImage: 'url('+ $root.user.imageUrl +')' }" style="background-size: contain;"></div>

                <div class="col box-text">
                  <h4 class="name" style="font-size: .8rem;">{{ $root.user.name }}  {{ $root.user.lastname }}</h4>
                  <h6 class="position">{{ $root.user.position }}</h6>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      headerHeight: 0,
    }
  },

  methods: {
    getHeaderHeight() {
      this.headerHeight = document.querySelector('.header-content').offsetHeight;
    },
  },

  mounted() {
    this.getHeaderHeight();
  },

  updated() {
    this.getHeaderHeight();
  },

  created() {
    window.addEventListener("resize", this.getHeaderHeight);
  },

  destroyed() {
    window.removeEventListener("resize", this.getHeaderHeight);
  },
}
</script>
